// extracted by mini-css-extract-plugin
module.exports = {"luckBg":"LuckyWheel_luckBg__xVwfn"};